function LandingPage() {
    return (
        <div className="text-center p-4 m-4">
            <h2 className="text-5xl font-bold">Share via writing, hope you enjoy</h2>
            <p className="mt-4 text-lg">Increase your knowledge by reading new things and i will share whatever I know for you, as long as I enjoy it</p>
        </div>
    );
}

export default LandingPage;